import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { getAppRoot } from "@/onload/loadConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionOperations',
    props: {
        dsc: null
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const downloadUrl = computed(() => `${getAppRoot()}api/dataset_collections/${props.dsc.id}/download`);
        const rerunUrl = computed(() => props.dsc.job_source_type == "Job" ? `/root?job_id=${props.dsc.job_source_id}` : null);
        const showCollectionDetailsUrl = computed(() => props.dsc.job_source_type == "Job" ? `/jobs/${props.dsc.job_source_id}/view` : null);
        const disableDownload = props.dsc.populated_state !== "ok";
        function onDownload() {
            window.location.href = downloadUrl.value;
        }
        return { __sfc: true, router, props, downloadUrl, rerunUrl, showCollectionDetailsUrl, disableDownload, onDownload };
    }
});
